<template>
  <div style="padding-top: 96px; margin: 0 auto; text-align: center">
    <img :src="result ? creditGood : creditBad">
    <p v-if="result" style="margin-top: 20px">您的信用良好，欢迎到功夫好车门店办理业务</p>
    <p v-else style="margin-top: 20px">很抱歉，您的信用资质不佳</p>
  </div>
</template>

<script>
import creditGood from '@/assets/app/credit-good.png';
import creditBad from '@/assets/app/credit-bad.png';
export default {
  name: 'creditResult',
  data () {
    const { result } = this.$route.params;
    return {
      creditGood,
      creditBad,
      result: +result
    };
  }
};
</script>

<style scoped>

</style>
